let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("buBrD")).then(() => parcelRequire('cWftq'));